import * as React from "react";
const SvgFiRr8 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M15.305 8.723C16.337 7.806 17 6.485 17 5c0-2.757-2.243-5-5-5S7 2.243 7 5c0 1.485.664 2.806 1.695 3.723C5.93 9.984 4 12.768 4 16c0 4.411 3.589 8 8 8s8-3.589 8-8c0-3.232-1.93-6.016-4.695-7.277M9 5c0-1.654 1.346-3 3-3s3 1.346 3 3-1.346 3-3 3-3-1.346-3-3m3 17c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6"
    />
  </svg>
);
export default SvgFiRr8;
